/**
 * 枚舉
 * Tabler Icon
 * @author J
 * @since 2024-05-20 12:07:25
 */

export const TablerIconEnum = Object.freeze({

    /**
     * x
     */
    X: 0,

    /**
     * BRAND_APPLE
     */
    BRAND_APPLE: 1,

    /**
     * BRAND_ANDROID
     */
    BRAND_ANDROID: 2,

    /**
     * settings-automation
     */
    SETTINGS_AUTOMATION: 3,

    /**
     * broadcast
     */
    BROADCAST: 4,

    /**
     * letter-o
     */
    LETTER_O: 5,

    /**
     * letter-d
     */
    LETTER_D: 6,

    /**
     * letter-w
     */
    LETTER_W: 7,

    /**
     * letter-m
     */
    LETTER_M: 8,

    /**
     * letter-y
     */
    LETTER_Y: 9,

    /**
     * antenna-bars-5
     */
    ANTENNA_BARS_5: 10,

    /**
     * copy
     */
    COPY: 11,

    /**
     * dots
     */
    DOTS: 12,

    /**
     * viewfinder
     */
    VIEW_FINDER: 13,

    /**
     * bell
     */
    BELL: 14,

    /**
     * repeat
     */
    REPEAT: 15,

    /**
     * shield-lock
     */
    SHIELD_LOCK: 16,

    /**
     * shield-check
     */
    SHIELD_CHECK: 17,

    /**
     * history
     */
    HISTORY: 18,

    /**
     * file-orientation
     */
    FILE_ORIENTATION: 19,

    /**
     * book-upload
     */
    BOOK_UPLOAD: 20,

    /**
     * link
     */
    LINK: 21,

    /**
     * unlink
     */
    UNLINK: 22,

    /**
     * trash
     */
    TRASH: 23,

    /**
     * clock
     */
    CLOCK: 24,

    /**
     * hourglass-empty
     */
    HOURGLASS_EMPTY: 25,

    /**
     * flag
     */
    FLAG: 26,

    /**
     * arrow-back-up
     */
    ARROW_BACK_UP: 27,

    /**
     * flame
     */
    FLAME: 28,

    /**
     * ban
     */
    BAN: 29,

    /**
     * home
     */
    HOME: 30,

    /**
     * star
     */
    STAR: 31,

    /**
     * building
     */
    BUILDING: 32,

    /**
     * id-badge2
     */
    ID_BADGE2: 33,

    /**
     * user
     */
    USER: 34,

    /**
     * user-check
     */
    USER_CHECK: 35,

    /**
     * users-group
     */
    USERS_GROUP: 36,

    /**
     * code
     */
    CODE: 37,

    /**
     * code
     */
    TAG: 38,

    /**
     * lock
     */
    LOCK: 39,

    /**
     * plus
     */
    PLUS: 40,

    /**
     * search
     */
    SEARCH: 41,

    /**
     * check
     */
    CHECK: 42,

    /**
     * minus
     */
    MINUS: 43,

    /**
     * brand-youtube
     */
    BRAND_YOUTUBE: 44,

    /**
     * photo
     */
    PHOTO: 45,

    /**
     * paperclip
     */
    PAPERCLIP: 46,

    /**
     * pencil
     */
    PENCIL: 47,

    /**
     * pencil-off
     */
    PENCIL_OFF: 48,

    /**
     * prompt
     */
    PROMPT: 49,

    /**
     * gauge
     */
    GAUGE: 50,

    /**
     * headset
     */
    HEADSET: 51,

    /**
     * timeline
     */
    TIMELINE: 52,

    /**
     * chart-line
     */
    CHART_LINE: 53,

    /**
     * map-pin
     */
    MAP_PIN: 54,

    /**
     * hand-stop
     */
    HAND_STOP: 55,

    /**
     * loader-2
     */
    LOADER_2: 56,

    /**
     * caret-up
     */
    CARET_UP: 57,

    /**
     * caret-down
     */
    CARET_DOWN: 58,

    /**
     * zoom-in
     */
    ZOOM_IN: 59,

    /**
     * zoom-out
     */
    ZOOM_OUT: 60,

    /**
     * zoom-exclamation
     */
    ZOOM_EXCLAMATION: 61,

    /**
     * arrows-maximize
     */
    ARROWS_MAXIMIZE: 62,

    /**
     * download
     */
    DOWNLOAD: 63,

    /**
     * sun
     */
    SUN: 64,

    /**
     * moon
     */
    MOON: 65,

    /**
     * rotate-clockwise-2
     */
    ROTATE_CLOCKWISE_2: 66,

    /**
     * square-check
     */
    SQUARE_CHECK: 67,

    /**
     * baseline-density-medium
     */
    BASELINE_DENSITY_MEDIUM: 68,

    /**
     * microphone
     */
    MICROPHONE: 69,

    /**
     * message-circle
     */
    MESSAGE_CIRCLE: 70,

    /**
     * chevron-right
     */
    CHEVRON_RIGHT: 71,

    /**
     * arrow-left
     */
    ARROW_LEFT: 72,

    /**
     * arrow-right
     */
    ARROW_RIGHT: 73,

    /**
     * arrow-top
     */
    ARROW_TOP: 74,

    /**
     * arrow-down
     */
    ARROW_DOWN: 75,

    /**
     * arrow-bar-to-up
     */
    ARROW_BAR_TO_UP: 76,

    /**
     * arrow-bar-left
     */
    ARROW_BAR_LEFT: 77,

    /**
     * arrow-bar-right
     */
    ARROW_BAR_RIGHT: 78,

    /**
     * arrow-narrow-down
     */
    ARROW_NARROW_DOWN: 79,

    /**
     * exclamation-mark
     */
    EXCLAMATION_MARK: 80,

    /**
     * player-play-filled
     */
    PLAYER_PLAY_FILLED: 81,

    /**
     * adjustments-horizontal
     */
    ADJUSTMENTS_HORIZONTAL: 82,

    /**
     * question-mark
     */
    QUESTION_MARK: 83,

})